import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { CallbotAdminApp } from "./pages/CallbotAdminApp";
import { DevToolsErrorBoundary } from "./components/DevToolsErrorBoundary";
import { ToastProvider } from "./components/ui/Toast";
import { ConfirmProvider } from "./components/ui/ConfirmDialog";
import { initDevToolsErrorCapture } from "./lib/devToolsBoot";
import "./styles.css";

void initDevToolsErrorCapture();

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

createRoot(root).render(
  <StrictMode>
    <DevToolsErrorBoundary>
      <ToastProvider>
        <ConfirmProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/admin" replace />} />
              <Route path="/admin/*" element={<CallbotAdminApp />} />
            </Routes>
          </BrowserRouter>
        </ConfirmProvider>
      </ToastProvider>
    </DevToolsErrorBoundary>
  </StrictMode>,
);
